import { NgFor } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

import { EventModel, EventOption, EventOptionGroup } from '@frontend/sports/betting-offer/feature/model';
import { TrackingSource } from '@frontend/sports/tracking/feature';

import { EventPickComponent } from '../../option-pick/event-pick.component';
import { TreeOptionComponent } from './tree-option.component';

@Component({
    selector: 'ms-three-way-market',
    templateUrl: './three-way-market.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [EventPickComponent, NgFor, TreeOptionComponent],
})
export class ThreeWayMarketComponent {
    @Input() event: EventModel;
    @Input() activeMarket: EventOptionGroup;
    @Input() tracking: TrackingSource;
    @HostBinding('class') className = 'market-options';

    optionsTrackBy(index: number, option: EventOption): number {
        return option.id;
    }
}
